import { Badge as MaterialBadge, Menu } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { DoneAll } from "@mui/icons-material";
import { Grid, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { HiFlag } from "react-icons/hi";

export const NotificationMenuIcon = styled("div")(({ isOpen }: { isOpen: boolean }) => ({
  borderRadius: "15px",
  backgroundColor: isOpen ? "rgba(190, 219, 243)" : "rgba(48, 140, 219, 0.1)",
  marginRight: "16px",
  padding: "6px",
  cursor: "pointer",
  alignItems: "center",
  display: "flex",
}));

export const NotificationsBadgeCount = styled(MaterialBadge)(() => ({
  "& span": {
    backgroundColor: "#F97066",
    transform: "scale(1) translate(65%, -80%) !important",
    fontSize: ".55rem !important",
  },
}));

export const NotificationsMenuHeader = styled(Grid)(() => ({
  padding: "24px",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const NotificationsMenuListContainer = styled(Grid)(() => ({
  maxHeight: "278px",
  overflowY: "scroll",
  "&::-webkit-scrollbar": {
    display: "none",
  },
}));

export const NotificationsMenuListBottom = styled(Grid)(() => ({
  padding: "16px",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "16px",
}));

export const NotificationsMenuListSpinner = styled(CircularProgress)(() => ({
  color: "#000000",
}));

export const NotificationsMenuListEnd = styled("span")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#1D2939",
  paddingRight: "16px",
}));

export const NotificationsMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: "12px",
    overflow: "visible",
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
  },
  "& .MuiList-padding": {
    padding: "0px",
  },
}));

export const NotificationsHeaderItem = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const NotificationsMenuHeaderTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 800,
  fontSize: "20px",
  lineHeight: "28px",
  color: "#232325",
}));

export const NotificationsMenuBadge = styled("div")(() => ({
  background: "#12B76A !important",
  color: "#FFFFFF",
  borderRadius: 20,
  padding: "4px 7px",
  marginLeft: "16px",
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "110%",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
}));

export const MarkAllAsReadLoading = styled(CircularProgress)(() => ({
  color: "#308CDB",
  marginLeft: "10px",
}));

export const MarkAllAsRead = styled("span")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "150%",
  color: "#308CDB",
}));

export const MarkAllAsReadIcon = styled(DoneAll)(() => ({
  color: "#308CDB",
  fontSize: "14px",
  marginLeft: "10px",
}));

export const FromUserImage = styled("img")(() => ({
  width: "32px",
  height: "32px",
  borderRadius: "50%",
}));

export const NotificationsMenuItemDescription = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "150%",
  color: "#1C1C1C",
}));

export const NotificationsMenuItemTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "150%",
  color: "#232325",
}));

export const NotificationDate = styled("span")(() => ({
  fontFamily: "Manrope",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "160%",
  color: "#98A2B3",
}));

export const ImportantIconContainer = styled(Grid)(() => ({
  display: "flex",
  alignItems: "flex-end",
}));

export const LoadingIcon = styled(CircularProgress)(() => ({
  color: "#475467",
}));

export const NotificationsMenuFooter = styled(Grid)(() => ({
  padding: "24px",
  justifyContent: "flex-end",
  alignItems: "center",
  background: "#F7F7F9",
  borderRadius: "0 0 12px 12px",
}));

export const SeeAllNotifications = styled("span")(() => ({
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "16px",
  marginRight: "10px",
  lineHeight: "24px",
  textAlign: "center",
  color: "#465869",
}));

export const ImportantIcon = styled(HiFlag, {
  shouldForwardProp: (props) => props !== "isImportant",
})(({ isImportant }: { isImportant: boolean }) => ({
  color: isImportant ? "#32D583" : "#667085",
  fontSize: "17px",
  cursor: "pointer",
}));

export const NotificationsMenuItemRead = styled(Grid, {
  shouldForwardProp: (props) => props !== "isRead",
})(({ isRead }: { isRead: boolean }) => ({
  padding: "16px 24px",
  background: isRead ? "#FFFFFF" : "#ECFDF3",
}));

const styles = makeStyles(() => ({
  menuPaper: {
    width: "520px",
    marginTop: "14px",
  },
}));

export default styles;
